import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props} viewBox="-2 -2 24 24">
    <path d="M19.6 5.2a2.5 2.5 0 00-1.8-1.8C16.2 3 10 3 10 3s-6.3 0-7.8.4A2.5 2.5 0 00.4 5.2 25.9 25.9 0 000 10a25.9 25.9 0 00.4 4.8 2.5 2.5 0 001.8 1.8c1.5.4 7.8.4 7.8.4s6.3 0 7.8-.4a2.5 2.5 0 001.8-1.8A25.9 25.9 0 0020 10a25.9 25.9 0 00-.4-4.8zM8 13V7l5.2 3z" />
  </BaseIcon>
)
